// src/pages/ProfileGate/steps/OnboardingCompleteStep.jsx

import React, {
  useEffect,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import ProfileGateShell from "../../../components/profile-gate/ProfileGateShell";

import {
  supabase,
} from "../../../supabaseClient";

const READY_PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/In-App/Gwin-Run.png";

const READY_ITEMS = [
  {
    title: "Know",
    description:
      "See your weekly actions to stay on top of things",
  },
  {
    title: "Learn",
    description:
      "Build your business-finance knowledge step by step.",
  },
  {
    title: "Do",
    description:
      "Take action in your business and check-in",
  },
  {
    title: "Progress",
    description:
      "See what you've learned and how your financial habits are developing.",
  },
];

function ReadyItem({
  title,
  description,
}) {
  return (
    <div className="flex items-start gap-4">
      <div
        className="
          mt-[2px]
          flex
          h-7
          w-7
          shrink-0
          items-center
          justify-center
          rounded-full
          bg-[#00BF63]
        "
      >
        <span className="text-[15px] font-bold leading-none text-white">
          ✓
        </span>
      </div>

      <div>
        <h2 className="text-[16px] font-bold leading-snug text-[#222222] sm:text-[17px]">
          {title}
        </h2>

        <p className="mt-1 text-[14px] leading-relaxed text-[#757575] sm:text-[15px]">
          {description}
        </p>
      </div>
    </div>
  );
}

function BottomActionCard({
  title,
  description,
}) {
  return (
    <div
      className="
        w-full
        rounded-[18px]
        border-2
        border-[#E6E6E6]
        bg-white
        px-5
        py-5
        text-left
      "
    >
      <h3 className="text-[16px] font-bold text-[#222222]">
        {title}
      </h3>

      <p className="mt-2 text-[13px] leading-relaxed text-[#757575] sm:text-[14px]">
        {description}
      </p>
    </div>
  );
}

export default function OnboardingCompleteStep() {
  const navigate =
    useNavigate();

  const [
    loadingAccess,
    setLoadingAccess,
  ] = useState(true);

  const [
    isTrialEligible,
    setIsTrialEligible,
  ] = useState(false);

  useEffect(() => {
    let cancelled = false;

    async function loadAccessStatus() {
      try {
        setLoadingAccess(true);

        const {
          data,
          error,
        } =
          await supabase.rpc(
            "get_my_gwin_trial_status"
          );

        if (error) {
          throw error;
        }

        if (cancelled) {
          return;
        }

        setIsTrialEligible(
          data?.eligible === true
        );
      } catch (error) {
        console.warn(
          "Could not check onboarding trial status:",
          error
        );

        if (!cancelled) {
          setIsTrialEligible(
            false
          );
        }
      } finally {
        if (!cancelled) {
          setLoadingAccess(
            false
          );
        }
      }
    }

    loadAccessStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  const heading =
    isTrialEligible
      ? "Your 14-day Gwin trial is ready"
      : "Your Gwin journey is ready";

  return (
    <ProfileGateShell
  showBack={true}
  showSpeechPenguin={false}
  nextLabel="Continue"
  nextDisabled={
    loadingAccess
  }
  onBack={() =>
  navigate("/profile-gate/orientation")
}
  onNext={() =>
    navigate(
      "/profile-gate/consent-notices",
      {
        state: {
          returnTo:
            "/dashboard",
          consentReason:
            "initial_onboarding",
        },
      }
    )
  }
>
      <div className="mx-auto mt-4 w-full max-w-[560px]">
        {loadingAccess ? (
          <div className="py-12 text-center">
            <p className="text-[15px] font-semibold text-[#757575]">
              Getting Gwin ready for you...
            </p>
          </div>
        ) : (
          <>
            <div className="mx-auto w-[52%] max-w-[240px]">
              <img
                src={
                  READY_PENGUIN_URL
                }
                alt="Gwin"
                className="h-auto w-full object-contain"
                loading="eager"
                decoding="async"
                draggable="false"
              />
            </div>

            <h1
              className="
                mx-auto
                mt-4
                max-w-[470px]
                text-center
                text-[24px]
                font-bold
                leading-tight
                text-[#222222]
                sm:text-[28px]
              "
            >
              {heading}
            </h1>

            <div className="mx-auto mt-8 max-w-[500px] space-y-6">
              {READY_ITEMS.map(
                (
                  item
                ) => (
                  <ReadyItem
                    key={
                      item.title
                    }
                    title={
                      item.title
                    }
                    description={
                      item.description
                    }
                  />
                )
              )}
            </div>

            {isTrialEligible ? (
              <p
                className="
                  mx-auto
                  mt-7
                  max-w-[480px]
                  text-center
                  text-[13px]
                  leading-relaxed
                  text-[#757575]
                "
              >
                Your trial gives you 14 days of access, with up to 6 completed levels during the trial.
              </p>
            ) : null}

            <div className="mx-auto mt-8 grid max-w-[500px] gap-3 sm:grid-cols-2">
  <BottomActionCard
    title="Invite 5 friends"
    description="Refer 5 friends to Gwin and receive a free 1-month subscription as your reward. T&Cs apply."
  />

  <BottomActionCard
    title="Subscribe"
    description="Subscribe for only R69 per month to continuing enjoying Gwin’s features."
  />
</div>
          </>
        )}
      </div>
    </ProfileGateShell>
  );
}